import React, { useState } from "react";
import { Page } from "@/components/Layout";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, HandHeart } from "@phosphor-icons/react";

export default function ReferUs() {
  const [form, setForm] = useState({ referrer_name: "", referrer_email: "", referred_name: "", referred_email: "", division: "couch", message: "" });
  const [done, setDone] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/referrals", form);
      setDone(r.data);
      toast.success("Referral submitted, thank you.");
    } catch { toast.error("Failed to submit referral"); }
  };

  if (done) return (
    <Page>
      <section className="md-section"><div className="md-container max-w-xl text-center">
        <HandHeart size={64} weight="duotone" style={{ color: "var(--md-accent)" }} className="mx-auto" />
        <h1 className="text-4xl font-serif mt-6">Thank you for caring</h1>
        <p className="mt-3" style={{ color: "var(--md-text-soft)" }}>Your referral code: <strong>{done.referral_code}</strong></p>
        <p className="mt-2 text-sm" style={{ color: "var(--md-text-muted)" }}>We'll reach out to {done.referred_name} respectfully and at their pace.</p>
      </div></section>
    </Page>
  );

  return (
    <Page>
      <section className="md-section md-page-hero" data-testid="refer-hero">
        <div className="md-container text-center">
          <div className="md-label-eyebrow mb-3">Refer to Us</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif" data-testid="refer-hero-title">
            Someone <em>in mind?</em>
          </h1>
          <p className="text-base mt-5 max-w-2xl mx-auto">
            Refer a friend, family member, colleague or student. We&apos;ll reach out gently, at their pace.
          </p>
        </div>
      </section>

      <section className="md-section">
        <div className="md-container max-w-2xl">
          <form onSubmit={submit} className="md-card grid md:grid-cols-2 gap-4" data-testid="referral-form">
            <div><label className="md-label-eyebrow block mb-2">Your name</label><input required className="md-input" value={form.referrer_name} onChange={(e) => setForm({ ...form, referrer_name: e.target.value })} data-testid="ref-referrer-name" /></div>
            <div><label className="md-label-eyebrow block mb-2">Your email</label><input required type="email" className="md-input" value={form.referrer_email} onChange={(e) => setForm({ ...form, referrer_email: e.target.value })} data-testid="ref-referrer-email" /></div>
            <div><label className="md-label-eyebrow block mb-2">Their name</label><input required className="md-input" value={form.referred_name} onChange={(e) => setForm({ ...form, referred_name: e.target.value })} data-testid="ref-referred-name" /></div>
            <div><label className="md-label-eyebrow block mb-2">Their email</label><input required type="email" className="md-input" value={form.referred_email} onChange={(e) => setForm({ ...form, referred_email: e.target.value })} data-testid="ref-referred-email" /></div>
            <div className="md:col-span-2"><label className="md-label-eyebrow block mb-2">Division</label>
              <select className="md-input" value={form.division} onChange={(e) => setForm({ ...form, division: e.target.value })} data-testid="ref-division">
                <option value="couch">Couch</option><option value="forward">Forward</option><option value="not_sure">Not Sure</option>
              </select>
            </div>
            <div className="md:col-span-2"><label className="md-label-eyebrow block mb-2">Message (optional)</label>
              <textarea className="md-input" rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="ref-message" />
            </div>
            <button type="submit" className="btn-primary md:col-span-2 justify-center" data-testid="referral-submit">Submit Referral <ArrowRight size={14} weight="bold" /></button>
          </form>
        </div>
      </section>
    </Page>
  );
}
